import { META_LAYOUT } from "@core/constants";
import { ETAB_ROUTES, ETAB_LAYOUTS } from "@etab/config";

import SuccessPage from "./Success.page.vue";

export default function () {
  return [
    {
      path: ETAB_ROUTES.creationSuccess.path,
      name: ETAB_ROUTES.creationSuccess.name,
      component: SuccessPage,
      meta: { [META_LAYOUT]: ETAB_LAYOUTS.success },
    },
  ];
}
